<i nz-icon [nzType]="'info-circle'"></i>

<div id="modal-content">
  <p [innerHTML]="message"></p>
</div>
